import { inject } from '@angular/core';
import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { MaintenanceService } from '../services/maintenance.service';

export const SKIP_GLOBAL_ERROR_REDIRECT = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const maintenance = inject(MaintenanceService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (req.context.get(SKIP_GLOBAL_ERROR_REDIRECT)) {
        return throwError(() => error);
      }

      if (error.status === 0 && !navigator.onLine) {
        router.navigate(['/offline']);
        return throwError(() => error);
      }

      if (maintenance.markFromHttpError(error) && !router.url.startsWith('/admin') && !router.url.startsWith('/maintenance')) {
        router.navigate(['/maintenance']);
      }

      return throwError(() => error);
    })
  );
};
